import {Component, OnInit, ViewChild} from '@angular/core';
import {ObjectStatus} from "../object-status";
import {MatSort} from "@angular/material/sort";
import {MatTableDataSource} from "@angular/material/table";
import {Subscription} from "rxjs";
import {ApiService} from "../services/api.service";
import {LoadService} from "../services/load.service";
import {AuthService} from "../auth/auth.service";

@Component({
  selector: 'app-download',
  templateUrl: './download.component.html',
  styleUrls: ['./download.component.css']
})
export class DownloadComponent implements OnInit {

  status: ObjectStatus[] = [];
  // @ts-ignore
  @ViewChild(MatSort) sort: MatSort;
  displayedColumns: string[] = [
    "file_name",
    "file_size",
    "owner_email",
    "upload_date",
    "deletion_date",
    "malware_scan_status",
    "buttons"
  ];
  dataSource = new MatTableDataSource<ObjectStatus>();

  flag_loader = true;
  statusSubscription: Subscription | null = null

  constructor(
    private apiService: ApiService,
    private loadService: LoadService
  ) {
  }

  ngOnInit(): void {
    this.loadStatus()
  }

  ngAfterViewInit() {
    this.dataSource.sort = this.sort;
  }

  ngOnDestroy() {
    if (this.statusSubscription) this.statusSubscription.unsubscribe()
  }

  loadStatus() {
    this.statusSubscription = this.apiService.getDownloadableFiles().subscribe(
      (result: ObjectStatus[]) => {
        this.status = result;
        this.flag_loader = false
        this.dataSource.data = this.status;
      },
      (error: any) => {
        console.log(error);
      }
    );
  }

  download(objectKey: string, fileName: string): void {
    this.apiService.getDownloadUrl(objectKey).subscribe((response: any) => {
      this.loadService
        .download(response.download_url, fileName)
    })
  }

}
